import styled from "styled-components";
import { SmBannerImg } from "../../styled/AllImages";

export const SmBanner = styled.div`
    .smBannerInner{
        display: flex;
        height: 100%;
        min-height: 250px;
        align-items: center;
        background-image: url(${SmBannerImg});
        background-repeat: no-repeat;
        background-size: cover;
        background-position: center;
        border-radius: 10px;
        overflow: hidden;
        box-shadow: 0px 0px 5px rgba(0, 0, 0, .1);
        cursor: pointer;
    }
    
    @media (max-width: 991px) {
        width: 100%;
    }
    @media (max-width: 767px) {
        /* border-radius: 0px; */
        /* box-shadow: none; */
        padding-left: 16px;
        padding-right: 16px;
        background-color: var(--white);
    }
    
`
export const LookingForWrapper = styled.div`
    display: flex;
	width: 100%;
    flex-wrap: wrap;
    height: 100%;
    align-items: center;
    .lookingForContent{
        display: flex;
        width: 100%;
        flex-wrap: wrap;
        position: relative;
        padding: 24px;
        & > *{
            width: 100%;
        }
        .sRHeadingWrapper{
            position: relative;
            .sRHeading{
                background: var(--bgGradient1);
                -webkit-background-clip: text;
                -webkit-text-fill-color: transparent;
                width: fit-content;
                position: relative;
                font-size: 35px;
                body.rtl &{
                    font-size: 40px;
                }
            }
            .sRHeadingOne{
                z-index: 2;
            }
            .sRHeadingSec{
                position: absolute;
                z-index: 1;
                top: 3px;
                opacity: .6;
            }
        }
        .fillOut{
            position: relative;
            width: fit-content;
            z-index: 2;
            margin-top: 5px;
            &:before{
                content: '';
                background-color: var(--themeColor);
                position: absolute;
                z-index: -1;
                width: 100% ;
                height: 27px;
                left: 0;
                right: 0;
                top: 2px;
                body.rtl &{
                    top: 3px;
                }
            }
            
        }
        & img{
            position: absolute;
            right: 0;
            bottom: -10px;
            width: auto;
            transform: scaleX(-1) !important;
            -webkit-transform: scaleX(-1) !important;
            -moz-transform: scaleX(-1) !important;
            -ms-transform: scaleX(-1) !important;
            -o-transform: scaleX(-1) !important;
        }
    }
    @media (max-width: 1299px) {
        .lookingForContent{
            .propertySmBannerIcon{
                width: 120px;
                /* right: -10px; */
                bottom: 30px;
            }
        }
        
    }
    @media (max-width: 1199px) {
        .lookingForContent{
            .propertySmBannerIcon{
                width: 100px;
                /* right: -10px; */
                bottom: 30px;
            }
        }
        
    }
    @media (max-width: 991px) {
        .lookingForContent{
            .propertySmBannerIcon{
                width: 150px;
                bottom: 17px;
            }
        }
        
    }
    @media (max-width: 500px) {
        .lookingForContent{
            /* padding-right: 150px; */
            .sRHeadingWrapper {
                .sRHeading {
                    line-height: 1.2;
                }
            }
        }
        
    }
    @media (max-width: 399px) {
        .lookingForContent{
            /* padding-right: 24px; */
            .sRHeadingWrapper {
                .sRHeading {
                    line-height: 1.2;
                }
            }
            .propertySmBannerIcon{
               display: none;
            }
        }
        
    }
`